/**
 * BusStopMarker
 * 
 * @Author: Focci
 * @Date: 2024-09-03 10:20:26
 * @Last Modified by: Focci
 * @Last Modified time: 2024-09-03 10:20:26
 */

// import PropTypes from 'prop-types'
import SVGBusStop from '@img/bus-stop.svg'
import clsx from 'clsx'
import { forEach, isArray } from 'lodash-es'
import { useCallback } from 'react'
import { Marker } from 'react-map-gl'
import { useMapState } from '..'

export default function BusStopMarker() {
  const { busStops, setPopups, popups } = useMapState()

  const handleMarkerClick = useCallback((item) => {
    setPopups([{
      type: 'busStop',
      data: item
    }])
  }, [setPopups])

  // 判断是否选中
  const isSelected = useCallback((item) => {
    const target = isArray(popups) ? popups : []
    const ids = []
    forEach(target, (t) => ids.push(t.data?.id))

    return ids.includes(item.id)
  }, [popups])

  return busStops.map((item) => (
    <Marker
      key={item.id}
      latitude={item.lat}
      longitude={item.lng}
      onClick={() => handleMarkerClick(item)}
    >
      <div 
        className={clsx([
          'inline-flex cursor-pointer',
          isSelected(item) ? 'text-[#4157ff]' : 'text-[#afbddc]'
        ])}
      >
        <SVGBusStop />
      </div>
    </Marker>
  ))
}

// BusStopMarker.propTypes = {
//   className: PropTypes.string,
// }
